// extracted by mini-css-extract-plugin
export default {"image":"cover_image__XoopF","text":"cover_text__JCVHi","mouse_btn":"cover_mouse_btn__vti8b","mouse_scroll":"cover_mouse_scroll__vecMy","scrolling":"cover_scrolling__gI3Hu"};